// extracted by mini-css-extract-plugin
export default {"price":"price_price__CoFxX","data_number":"price_data_number__-WRoa"};